// extracted by mini-css-extract-plugin
module.exports = {"subheadline":"subheadline-m__subheadline__3H1ig","dark":"subheadline-m__dark__31XBm","light":"subheadline-m__light__kaSyy"};